/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const OverviewPage = lazy(() => import('./pages/OverviewPage'))

export const dashboardRoutes: RouteObject[] = [
  {
    index: true,
    element: <OverviewPage />,
  },
]
